const initialState = {}

export default (state = initialState, { type, payload }) => {
  switch (type) {

  case "ADD_ACCORDIAN_STATE":
    return { ...state, ...payload }


    case "UPDATE_ACCORDIAN_STATE":
        return { ...state, ...payload }

  default:
    return state
  }
}
